<div class="home-page-grey-card">
	<dz-card [cardOptions]="{ isSelectable: false, backgroundColor: '#EAE7E1' }">
		<dz-card-title align="left" class="text-24-bold dz-underline">
			<a
				[dcrHTMLKey]="'DESCRIPTION_' + familyData?.familyId?.formattedValue"
				[routerLink]="[appPaths.FAMILY]"
				[queryParams]="{
					familyId: familyData?.familyId,
					groupId: blkFamilyGroup
				}"
				queryParamsHandling="merge"
				custom-tracking
				[track-event]="
					TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
					':' +
					TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_HOME_PAGE +
					':portfolio selection card:' +
					familyData.description
				"
			>
				{{ familyData?.description }}
			</a>
		</dz-card-title>
		<dz-card-subtitle align="left" class="text-14" [dcrHTMLKey]="'OBJECTIVE_' + familyData?.aladdinTicker?.formattedValue"
			>{{ familyData?.objective | trim }}
		</dz-card-subtitle>
		<div class="dz-grid">
			<div class="dz-row">
				<div class="dz-col-md-16">
					<div class="text-14-bold" dcrHTMLKey="PORTFOLIOS_HOME_PAGE_GREY_CARD_LABEL">Portfolios</div>
					<ul class="padding-bottom-object-2">
						<li *ngFor="let portfolio of portfolioData; let rowIndex = index">
							<dz-checkbox
								(change)="selectedModelsChanged.emit({ rowData: portfolio, checked: $event.checked })"
								[disabled]="selectedModelIds.length >= (isMobile ? 1 : 3) && selectedModelIds.indexOf(portfolio.modelId.toString()) === -1"
								[checked]="selectedModelIds.indexOf(portfolio.modelId.toString()) >= 0"
								custom-tracking
								[track-event]="
									TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
									':' +
									TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_HOME_PAGE +
									':portfolio selection card:modelId:' +
									portfolio?.modelId +
									':familyId:' +
									portfolio?.familyId +
									':checked:' +
									(selectedModelIds.indexOf(portfolio.modelId.toString()) >= 0 ? 'false' : 'true')
								"
								>{{ portfolio.modelShortName }}</dz-checkbox
							>
						</li>
					</ul>
				</div>

				<div class="dz-col-md-8 dz-text-align-right-sm">
					<div class="text-14-bold" dcrHTMLKey="HOME_PAGE_VEHICLE_LABEL">Vehicle</div>
					<div class="margin-bottom-object-5" [dcrHTMLKey]="'VEHICLE_' + familyData.vehicle.formattedValue">{{ familyData?.vehicle | trim }}</div>
					<div class="text-14-bold" dcrHTMLKey="HOME_PAGE_TRADE_FREQUENCY_LABEL">Trade Frequency *</div>
					<div [dcrHTMLKey]="'TRADEFREQ_' + familyData.tradeFrequency.formattedValue">
						<!-- Using span to allow html content -->
						<span [innerHTML]="familyData?.tradeFrequency"></span>
					</div>
				</div>
			</div>
		</div>
	</dz-card>
</div>
